import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\DeleteCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/DeleteCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
const DeleteCustomActivityLogController = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCustomActivityLogController.url(args, options),
    method: 'delete',
})

DeleteCustomActivityLogController.definition = {
    methods: ["delete"],
    url: '/api/activity/{activity}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ActivityLog\DeleteCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/DeleteCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
DeleteCustomActivityLogController.url = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { activity: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { activity: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            activity: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        activity: typeof args.activity === 'object'
        ? args.activity.id
        : args.activity,
    }

    return DeleteCustomActivityLogController.definition.url
            .replace('{activity}', parsedArgs.activity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\DeleteCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/DeleteCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
DeleteCustomActivityLogController.delete = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCustomActivityLogController.url(args, options),
    method: 'delete',
})

export default DeleteCustomActivityLogController